var ko = require('knockout');
var $ = require('jquery');

ko.components.register('my-courses-block', {
  viewModel: require('./my-courses-block'),
  template: require('./my-courses-block.template')
});

$('[data-my-courses-block]').each(function() {
  ko.applyBindings({}, this);
});
